var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',{attrs:{"small":"","color":_vm.status.color}},[_c('span',{staticClass:"text-caption white--text text--bolder"},[_vm._v(_vm._s(_vm.displayLabel))])])
}
var staticRenderFns = []

export { render, staticRenderFns }